/**
 * The hero's population bar — every card on the tab, split by what can actually
 * be done with it.
 *
 * THE LEGEND ALWAYS RENDERS, zeros included. This is the whole reason the
 * component is shared rather than written twice: Moments had the rule and the
 * other three tabs did not, so a tab whose findings all fell into one bucket
 * lost its bar entirely and the hero read as though the analysis had not run.
 * "0 can apply" is information — it is the answer to the question the tab
 * exists to ask.
 *
 * Only the SEGMENTS are dropped at zero, so the rounded end caps land on a
 * visible one. With nothing counted at all the track would be an empty pill
 * saying nothing, so it goes and the legend of zeros carries the row.
 */
export default function PopBar({ segments = [] }) {
  const total = segments.reduce((sum, s) => sum + s.n, 0);
  const pct = (n) => `${((n / total) * 100).toFixed(1)}%`;
  if (!segments.length) return null;
  return (
    <>
      {total ? (
        <div className="pop">
          {segments.filter((s) => s.n).map((s) => (
            <span key={s.cls} className={s.cls} style={{ width: pct(s.n) }} />
          ))}
        </div>
      ) : null}
      <div className="popkey">
        {segments.map((s) => (
          <span key={s.cls}><i className={s.cls} /><b>{s.n}</b> {s.label}</span>
        ))}
      </div>
    </>
  );
}
